<template>
  <div
    v-if="events.length > 1"
    id="event-selector"
  >
    <v-select
      v-model="eventId"
      :items="events"
      item-text="name"
      item-value="id"
      label="Event"
      @change="change"
    />
  </div>
</template>

<script>
export default {
  name: 'EventSelector',
  props: {
    events: {
      type: [Object, Array],
      default: () => {},
    },
    selectedId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      eventId: this.selectedId,
    };
  },
  methods: {
    change() {
      this.$emit('change', this.eventId);
    },
  },
};
</script>
